<template>
  <div class="hero-item-wrapper">
    <a
      class="hero-item"
      @click.prevent="goToHeroPage(hero.id)"
    >
      <img
        :src="heroImage(hero.id)"
        class="hero-image"
        height="183"
        width="180"
      >
      <p class="hero-name" v-html="hero.name" />
    </a>
  </div>
</template>

<script>
export default {
  name: 'hero-item',
  props: {
    hero: {
      type: Object,
      required: true
    }
  },
  methods: {
    goToHeroPage(heroId) {
      this.$router.push(`${this.$route.path}/heroes/${heroId}`)
      window.scrollTo(0, 0)
    },
    heroImage(heroId){
      return require(`@images/hero/faces/${heroId}.png`)
    },
  },
}
</script>

<style lang="scss" scoped>
.hero-item-wrapper {
  cursor: pointer;
  &:before {
    content: '';
    display: block;
    background: linear-gradient(to right, rgba(95,255,255,1) 0%,rgba(95,255,255,0.7) 70%,rgba(95,255,255,0) 100%);
    height: 2px;
    width: 640px;
  }
  .hero-item {
    display: flex;
    align-items: center;
    padding: 10px 97px 10px 20px;
    .hero-name {
      margin-left: 20px;
      font-size: $fs-xlarge;
      text-shadow: $ts-base;
    }
  }
}
</style>
